export default "__VITE_ASSET__66177df5__"